import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { story } from './storyblok/static-content'

import {
  traceFunction,
  tagError,
  getTraceId,
  setTag,
} from '@core/datadog-server'
import { getReviews } from '@cinch-nx/data-trustpilot'

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const ddMeta = {
    traceId: getTraceId(),
    traceTime: Date.now(),
  }

  const {
    stars: starRating,
    starRatingLabel,
    total: totalReviews,
  } = await getReviews()

  try {
    const HeroProps = story.content?.cfHero?.[0]

    setTag('response.code', 200)

    return {
      props: {
        story,
        trustpilotData: {
          starRatingLabel,
          totalReviews,
          starRating,
        },
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
        },
      },
      revalidate: 60,
    }
  } catch (error) {
    console.error(error)

    if (typeof error === 'string' || error instanceof Error) {
      tagError(error)
    }

    return {
      notFound: true,
      props: {
        ddMeta,
      },
      revalidate: 30,
    }
  }
}

export type CarFinancePageProps = InferGetStaticPropsType<typeof getStaticProps>

export const getStaticProps = traceFunction(
  'car-finance.getStaticProps',
  getStaticPropsfn,
)
